import React, { Fragment, useState, useEffect } from 'react';
import {
    Button,
    Row,
    Modal,
    ModalBody,
    ModalHeader,
    ModalFooter,
    Card,
    CardBody,
} from 'reactstrap';
export default function ErrorPopoup({ visible, toggle, tabname }) {

    return (
        <Modal isOpen={visible} toggle={toggle}>
            <ModalHeader toggle={toggle}>
                <span role="img" aria-label="warning">
                    ⚠️
                </span>
                Sorry!
            </ModalHeader>
            <ModalBody>
                <span>
                    You are in wrong integration,Please go back and choose the integration
                </span>
            </ModalBody>
            <ModalFooter>
                <Button
                    color="danger"
                    onClick={() => {
                        window.location.href =
                            tabname === "channels" ? "/app/pages/integration/channels" : "/app/pages/integration/applications"
                    }}
                    size="xs"
                >
                    Back To {tabname === "channels" ? "Channels" : "Applications"}
                </Button>
            </ModalFooter>
        </Modal>
    );
}